<template>
    <div data-test-id="l-reviews-edit-timeline-form">
        <div style="margin-top: -20px">
            <!-- Start -->

            <div class="row">
                <div class="col-md-5">
                    <h4 class="reviewSetupHeading color-dark">
                        <strong>{{ $t(`reviews.update.stepsKickoff`) }}</strong>
                    </h4>
                    <template v-if="!isTemplate">
                        <div class="row">
                            <div class="col-md-5">
                                <l-date-picker
                                    :label="``"
                                    :value="new Date(reviewCycle.status.startPlan)"
                                    :on-date-change="
                                        date => {
                                            if (date) {
                                                reviewCycle.status.startPlan = new Date(date);
                                            }
                                        }
                                    "
                                    :disabled="reviewCycle.timelineLocked"
                                />
                            </div>
                            <div class="col-md-7">
                                <l-time-picker
                                    :value="new Date(reviewCycle.status.startPlan)"
                                    :use-meridian-time="time.useMeridianTime"
                                    :disabled="reviewCycle.timelineLocked"
                                    @change="
                                        e => {
                                            if (
                                                e &&
                                                new Date(reviewCycle.status.startPlan).getTime() !==
                                                    e
                                            ) {
                                                reviewCycle.status.startPlan = new Date(e);
                                            }
                                        }
                                    "
                                />
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <l-input-text
                            type="text"
                            :label="``"
                            :placeholder="$t(`reviews.admin.labelDefinedLater`)"
                            disabled
                        />
                    </template>
                </div>
                <div class="col-md-7">
                    <h4 class="reviewSetupHeading color-dark">
                        {{ $t(`reviews.update.stepsActions`) }}
                    </h4>
                    <ul>
                        <li
                            v-show="
                                reviewCycle.peerReviewsEnabled && reviewCycle.peerNominationsEnabled
                            "
                        >
                            {{ $t(`reviews.update.stepsKickoffA1`) }}
                        </li>
                        <li v-show="reviewCycle.selfEvaluationsEnabled">
                            {{ $t(`reviews.update.stepsKickoffA2`) }}
                        </li>
                        <li v-show="reviewCycle.directReportReviewsEnabled">
                            {{ $t(`reviews.update.stepsKickoffA6`) }}
                        </li>
                        <li
                            v-show="
                                reviewCycle.peerReviewsEnabled &&
                                    !reviewCycle.peerNominationsEnabled &&
                                    !reviewCycle.peerSelfNominationsEnabled &&
                                    reviewCycle.peerApprovalEnabled
                            "
                        >
                            {{ $t(`reviews.update.stepsKickoffA3`) }}
                        </li>
                        <li v-show="reviewCycle.managerReviewsEnabled">
                            {{ $t(`reviews.update.stepsKickoffA4`) }}
                        </li>
                        <li
                            v-show="
                                reviewCycle.peerReviewsEnabled &&
                                    reviewCycle.peerSelfNominationsEnabled
                            "
                        >
                            {{ $t(`reviews.update.stepsKickoffA5`) }}
                        </li>
                        <li
                            v-show="
                                reviewCycle.peerReviewsEnabled &&
                                    !reviewCycle.peerNominationsEnabled &&
                                    !reviewCycle.peerApprovalEnabled &&
                                    !reviewCycle.peerSelfNominationsEnabled
                            "
                        >
                            {{ $t(`reviews.update.stepsKickoffA7`) }}
                        </li>
                    </ul>
                </div>
            </div>

            <!-- Deadline for peerNominations == start of peerReviews OR start of peerApprovals -->

            <div
                v-if="reviewCycle.peerReviewsEnabled && reviewCycle.peerNominationsEnabled"
                class="row"
            >
                <div class="col-md-5">
                    <h4 class="reviewSetupHeading color-dark">
                        <strong>{{ $t(`reviews.update.stepsPeerNomination`) }}</strong>
                    </h4>
                    <template v-if="!isTemplate">
                        <div class="row">
                            <div class="col-md-5">
                                <l-date-picker
                                    :label="``"
                                    :value="new Date(reviewCycle.status.peerNominationsPlan)"
                                    :on-date-change="
                                        date => {
                                            if (date) {
                                                reviewCycle.status.peerNominationsPlan = new Date(
                                                    date,
                                                );
                                            }
                                        }
                                    "
                                    :disabled="reviewCycle.timelineLocked"
                                />
                            </div>
                            <div class="col-md-7">
                                <l-time-picker
                                    :value="new Date(reviewCycle.status.peerNominationsPlan)"
                                    :use-meridian-time="time.useMeridianTime"
                                    :disabled="reviewCycle.timelineLocked"
                                    @change="
                                        e => {
                                            if (
                                                e &&
                                                new Date(
                                                    reviewCycle.status.peerNominationsPlan,
                                                ).getTime() !== e
                                            ) {
                                                reviewCycle.status.peerNominationsPlan = new Date(
                                                    e,
                                                );
                                            }
                                        }
                                    "
                                />
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="row">
                            <div class="col-md-5">
                                <l-input-text
                                    v-model="reviewCycle.status.peerNominationsDelay"
                                    style="margin-top: 0px"
                                    type="number"
                                    :label="``"
                                    placeholder=""
                                    :disabled="reviewCycle.timelineLocked"
                                />
                            </div>
                            <div class="col-md-7" style="margin-top: 5px">
                                <span>
                                    <l-text :text="$t(`reviews.admin.labelAfterPreviousStep`)" />
                                </span>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="col-md-7">
                    <h4 class="reviewSetupHeading color-dark">
                        {{ $t(`reviews.update.stepsActions`) }}
                    </h4>
                    <ul>
                        <li
                            v-show="
                                reviewCycle.peerReviewsEnabled &&
                                    reviewCycle.peerNominationsEnabled &&
                                    reviewCycle.peerApprovalEnabled
                            "
                        >
                            {{ $t(`reviews.update.stepsPeerApprovalA1`) }}
                        </li>
                        <li
                            v-show="
                                reviewCycle.peerReviewsEnabled &&
                                    reviewCycle.peerNominationsEnabled &&
                                    !reviewCycle.peerApprovalEnabled
                            "
                        >
                            {{ $t(`reviews.update.stepsPeerReviewsA1`) }}
                        </li>
                    </ul>
                </div>
            </div>

            <!-- Deadline for peerApproval == start of peerReviews -->

            <div
                v-if="reviewCycle.peerReviewsEnabled && reviewCycle.peerApprovalEnabled"
                class="row"
            >
                <div class="col-md-5">
                    <h4 class="reviewSetupHeading color-dark">
                        <strong>{{ $t(`reviews.update.stepsPeerApproval`) }}</strong>
                    </h4>
                    <template v-if="!isTemplate">
                        <div class="row">
                            <div class="col-md-5">
                                <l-date-picker
                                    :label="``"
                                    :value="new Date(reviewCycle.status.peerApprovalPlan)"
                                    :on-date-change="
                                        date => {
                                            if (date) {
                                                reviewCycle.status.peerApprovalPlan = new Date(
                                                    date,
                                                );
                                            }
                                        }
                                    "
                                    :disabled="reviewCycle.timelineLocked"
                                />
                            </div>
                            <div class="col-md-7">
                                <l-time-picker
                                    :value="new Date(reviewCycle.status.peerApprovalPlan)"
                                    :use-meridian-time="time.useMeridianTime"
                                    :disabled="reviewCycle.timelineLocked"
                                    @change="
                                        e => {
                                            if (
                                                e &&
                                                new Date(
                                                    reviewCycle.status.peerApprovalPlan,
                                                ).getTime() !== e
                                            ) {
                                                reviewCycle.status.peerApprovalPlan = new Date(e);
                                            }
                                        }
                                    "
                                />
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="row">
                            <div class="col-md-5">
                                <l-input-text
                                    v-model="reviewCycle.status.peerApprovalDelay"
                                    style="margin-top: 0px"
                                    type="number"
                                    :label="``"
                                    placeholder=""
                                    :disabled="reviewCycle.timelineLocked"
                                />
                            </div>
                            <div class="col-md-7" style="margin-top: 5px">
                                <span
                                    ><l-text :text="$t(`reviews.admin.labelAfterPreviousStep`)"
                                /></span>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="col-md-7">
                    <h4 class="reviewSetupHeading color-dark">
                        {{ $t(`reviews.update.stepsActions`) }}
                    </h4>
                    <ul>
                        <li>{{ $t(`reviews.update.stepsPeerReviewsA3`) }}</li>
                    </ul>
                </div>
            </div>

            <!-- Deadline for peerReviews == managerReviews start OR process ends -->

            <div
                v-if="
                    reviewCycle.peerReviewsEnabled ||
                        reviewCycle.selfEvaluationsEnabled ||
                        reviewCycle.directReportReviewsEnabled
                "
                class="row"
            >
                <div class="col-md-5">
                    <h4 class="reviewSetupHeading color-dark">
                        <strong>{{ $t(`reviews.update.stepsPeerReviews`) }}</strong>
                    </h4>
                    <template v-if="!isTemplate">
                        <div class="row">
                            <div class="col-md-5">
                                <l-date-picker
                                    :label="``"
                                    :value="new Date(reviewCycle.status.peerReviewsPlan)"
                                    :on-date-change="
                                        date => {
                                            if (date) {
                                                reviewCycle.status.peerReviewsPlan = new Date(date);
                                            }
                                        }
                                    "
                                    :disabled="reviewCycle.timelineLocked"
                                />
                            </div>
                            <div class="col-md-7">
                                <l-time-picker
                                    :value="new Date(reviewCycle.status.peerReviewsPlan)"
                                    :use-meridian-time="time.useMeridianTime"
                                    :disabled="reviewCycle.timelineLocked"
                                    @change="
                                        e => {
                                            if (
                                                e &&
                                                new Date(
                                                    reviewCycle.status.peerReviewsPlan,
                                                ).getTime() !== e
                                            ) {
                                                reviewCycle.status.peerReviewsPlan = new Date(e);
                                            }
                                        }
                                    "
                                />
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="row">
                            <div class="col-md-5">
                                <l-input-text
                                    v-model="reviewCycle.status.peerReviewsDelay"
                                    style="margin-top: 0px"
                                    type="number"
                                    :label="``"
                                    placeholder=""
                                    :disabled="reviewCycle.timelineLocked"
                                />
                            </div>
                            <div class="col-md-7" style="margin-top: 5px">
                                <span
                                    ><l-text :text="$t(`reviews.admin.labelAfterPreviousStep`)"
                                /></span>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="col-md-7">
                    <h4 class="reviewSetupHeading color-dark">
                        {{ $t(`reviews.update.stepsActions`) }}
                    </h4>
                    <ul>
                        <li v-show="reviewCycle.peerReviewsEnabled">
                            {{ $t(`reviews.update.stepsManagerReviewsA1`) }}
                        </li>
                        <li v-show="reviewCycle.selfEvaluationsEnabled">
                            {{ $t(`reviews.update.stepsManagerReviewsA2`) }}
                        </li>
                        <li v-show="reviewCycle.directReportReviewsEnabled">
                            {{ $t(`reviews.update.stepsManagerReviewsA6`) }}
                        </li>
                    </ul>
                </div>
            </div>

            <!-- Deadline for managerReviews == start of conversations OR end of process -->

            <div v-if="reviewCycle.managerReviewsEnabled" class="row">
                <div class="col-md-5">
                    <h4 class="reviewSetupHeading color-dark">
                        <strong>{{ $t(`reviews.update.stepsManagerReviews`) }}</strong>
                    </h4>
                    <template v-if="!isTemplate">
                        <div class="row">
                            <div class="col-md-5">
                                <l-date-picker
                                    :label="``"
                                    :value="new Date(reviewCycle.status.managerReviewsPlan)"
                                    :on-date-change="
                                        date => {
                                            if (date) {
                                                reviewCycle.status.managerReviewsPlan = new Date(
                                                    date,
                                                );
                                            }
                                        }
                                    "
                                    :disabled="reviewCycle.timelineLocked"
                                />
                            </div>
                            <div class="col-md-7">
                                <l-time-picker
                                    :value="new Date(reviewCycle.status.managerReviewsPlan)"
                                    :use-meridian-time="time.useMeridianTime"
                                    :disabled="reviewCycle.timelineLocked"
                                    @change="
                                        e => {
                                            if (
                                                e &&
                                                new Date(
                                                    reviewCycle.status.managerReviewsPlan,
                                                ).getTime() !== e
                                            ) {
                                                reviewCycle.status.managerReviewsPlan = new Date(e);
                                            }
                                        }
                                    "
                                />
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="row">
                            <div class="col-md-5">
                                <l-input-text
                                    v-model="reviewCycle.status.managerReviewsDelay"
                                    style="margin-top: 0px"
                                    type="number"
                                    :label="``"
                                    placeholder=""
                                    :disabled="reviewCycle.timelineLocked"
                                />
                            </div>
                            <div class="col-md-7" style="margin-top: 5px">
                                <span
                                    ><l-text :text="$t(`reviews.admin.labelAfterPreviousStep`)"
                                /></span>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="col-md-7">
                    <h4 class="reviewSetupHeading color-dark">
                        {{ $t(`reviews.update.stepsActions`) }}
                    </h4>
                    <ul>
                        <li v-show="reviewCycle.managerReviewsEnabled">
                            {{ $t(`reviews.update.stepsConversationsA1`) }}
                        </li>
                    </ul>
                </div>
            </div>

            <!-- Deadline for conversations -->

            <div
                v-if="
                    reviewCycle.managerReviewsEnabled && !reviewCycle.visibilityControlledByReviewee
                "
                class="row"
            >
                <div class="col-md-5">
                    <h4 class="reviewSetupHeading color-dark">
                        <strong>{{ $t(`reviews.update.stepsConversations`) }}</strong>
                    </h4>

                    <template v-if="!isTemplate">
                        <div class="row">
                            <div class="col-md-5">
                                <l-date-picker
                                    :label="``"
                                    :value="new Date(reviewCycle.status.conversationsPlan)"
                                    :on-date-change="
                                        date => {
                                            if (date) {
                                                reviewCycle.status.conversationsPlan = new Date(
                                                    date,
                                                );
                                            }
                                        }
                                    "
                                    :disabled="reviewCycle.timelineLocked"
                                />
                            </div>
                            <div class="col-md-7">
                                <l-time-picker
                                    :value="new Date(reviewCycle.status.conversationsPlan)"
                                    :use-meridian-time="time.useMeridianTime"
                                    :disabled="reviewCycle.timelineLocked"
                                    @change="
                                        time => {
                                            if (
                                                time &&
                                                new Date(
                                                    reviewCycle.status.conversationsPlan,
                                                ).getTime() !== time
                                            ) {
                                                reviewCycle.status.conversationsPlan = new Date(
                                                    time,
                                                );
                                            }
                                        }
                                    "
                                />
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="row">
                            <div class="col-md-5">
                                <l-input-text
                                    v-model="reviewCycle.status.conversationsDelay"
                                    style="margin-top: 0px"
                                    type="number"
                                    :label="``"
                                    placeholder=""
                                    :disabled="reviewCycle.timelineLocked"
                                />
                            </div>
                            <div class="col-md-7" style="margin-top: 5px">
                                <span
                                    ><l-text :text="$t(`reviews.admin.labelAfterPreviousStep`)"
                                /></span>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="col-md-7">
                    <h4 class="reviewSetupHeading color-dark">
                        {{ $t(`reviews.update.stepsActions`) }}
                    </h4>
                    <ul>
                        <li>{{ $t(`reviews.update.stepsConversationsEndA1`) }}</li>
                    </ul>
                </div>
            </div>

            <!-- Timezone notice -->
            <div v-if="!isTemplate">
                <hr />
                <p class="tw-text-gray-400">
                    {{ $t(`reviews.update.stepsTimezone`, { timezone: time.zone }) }}
                    {{ $t("reviews.update.stepsSoftDeadline") }}
                </p>
                <hr />
            </div>
        </div>

        <div class="invisible-divider">&nbsp;</div>

        <div v-if="error" id="error" class="alert alert-danger">
            <span>{{ error.message }}</span>
        </div>

        <div v-if="!['manager', 'employee'].includes(reviewCycle.createdAsRole)" class="row">
            <div class="col-md-4 col-md-offset-8">
                <button class="btn btn-primary btn-raised btn-block" type="button" @click="next()">
                    {{ $t(`reviews.admin.btnContinue`) }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import debounce from "lodash.debounce";

import LInputText from "@/components/LInputText";
import LText from "@/components/LText";
import LDatePicker from "@/components/LDatePicker";
import LTimePicker from "@/components/LTimePicker";

export default {
    components: {
        LInputText,
        LText,
        LDatePicker,
        LTimePicker,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        isTemplate: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            reviewCycle: {
                status: {},
            },
            error: null,
        };
    },
    computed: {
        ...mapGetters({
            user: "users/current/user",
            getTemplateDetails: "reviews/templates/details",
            getCycleDetails: "reviews/cycles/details",
        }),

        time() {
            return {
                hstep: 1,
                mstep: 30,
                useMeridianTime: this.user.teamSettings?.useMeridianTime ?? false, // AM/PM
                zone: Intl?.DateTimeFormat?.().resolvedOptions().timeZone,
            };
        },
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                this.reviewCycle = this.isTemplate
                    ? this.getTemplateDetails(this.id)
                    : this.getCycleDetails(this.id);

                this.setDefaultTimeline();
            },
        },
        reviewCycle: {
            deep: true,
            handler: debounce(function handler() {
                this.update();
            }, 1000),
        },
    },
    methods: {
        setDefaultTimeline() {
            if (
                this.reviewCycle &&
                this.reviewCycle.status &&
                !this.reviewCycle.status.peerNominationsDelay
            ) {
                this.$set(this.reviewCycle.status, "peerNominationsDelay", 7);
                this.$set(this.reviewCycle.status, "peerApprovalDelay", 14);
                this.$set(this.reviewCycle.status, "peerReviewsDelay", 21);
                this.$set(this.reviewCycle.status, "managerReviewsDelay", 28);
                this.$set(this.reviewCycle.status, "conversationsDelay", 35);
            }

            if (
                this.reviewCycle &&
                this.reviewCycle.status &&
                typeof this.reviewCycle.status.startPlan == "undefined"
            ) {
                this.$set(
                    this.reviewCycle.status,
                    "startPlan",
                    new Date(Date.now() + 7 * 86400000).setHours(9, 0, 0, 0),
                );
                this.$set(
                    this.reviewCycle.status,
                    "peerNominationsPlan",
                    new Date(Date.now() + 14 * 86400000).setHours(9, 0, 0, 0),
                );
                this.$set(
                    this.reviewCycle.status,
                    "peerApprovalPlan",
                    new Date(Date.now() + 21 * 86400000).setHours(9, 0, 0, 0),
                );
                this.$set(
                    this.reviewCycle.status,
                    "peerReviewsPlan",
                    new Date(Date.now() + 28 * 86400000).setHours(9, 0, 0, 0),
                );
                this.$set(
                    this.reviewCycle.status,
                    "managerReviewsPlan",
                    new Date(Date.now() + 35 * 86400000).setHours(9, 0, 0, 0),
                );
                this.$set(
                    this.reviewCycle.status,
                    "conversationsPlan",
                    new Date(Date.now() + 42 * 86400000).setHours(9, 0, 0, 0),
                );
            } else {
                this.$set(
                    this.reviewCycle.status,
                    "startPlan",
                    new Date(this.reviewCycle.status.startPlan),
                );
                this.$set(
                    this.reviewCycle.status,
                    "peerNominationsPlan",
                    new Date(this.reviewCycle.status.peerNominationsPlan),
                );
                this.$set(
                    this.reviewCycle.status,
                    "peerApprovalPlan",
                    new Date(this.reviewCycle.status.peerApprovalPlan),
                );
                this.$set(
                    this.reviewCycle.status,
                    "peerReviewsPlan",
                    new Date(this.reviewCycle.status.peerReviewsPlan),
                );
                this.$set(
                    this.reviewCycle.status,
                    "managerReviewsPlan",
                    new Date(this.reviewCycle.status.managerReviewsPlan),
                );
                this.$set(
                    this.reviewCycle.status,
                    "conversationsPlan",
                    new Date(this.reviewCycle.status.conversationsPlan),
                );
            }
        },

        async update() {
            this.error = null;

            try {
                if (this.isTemplate) {
                    await this.$store.dispatch({
                        type: "reviews/templates/update",
                        payload: { template: this.reviewCycle, scope: "timeline" },
                    });
                } else {
                    await this.$store.dispatch({
                        type: "reviews/cycles/update",
                        payload: { reviewCycle: this.reviewCycle, scope: "timeline" },
                    });
                }

                this.$emit("updated");
            } catch (err) {
                if (err?.response?.data?.message) {
                    this.error = { message: err?.response?.data?.message };
                }
            }
        },

        async next() {
            await this.update();

            if (this.error === null) {
                this.$emit("next");
            }
        },
    },
};
</script>
